var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwiftxMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1443 503",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1255.5 0L1186.5 3L1090.5 11L1000.5 22L885.5 40L769.5 62L672.5 83L508.5 123L505.5 124L505.5 126L636.5 112L793.5 98L1004.5 85L1065.5 83L1198.5 83L1324.5 91L1333.5 89L1343.5 84L1375.5 60L1439.5 20L1443 16.5L1442 10.5L1436.5 8L1372.5 2L1326.5 0L1256.5 0Z M1091.5 146L991.5 150L905.5 157L808.5 168L697.5 184L581.5 204L460.5 228L356.5 251L222.5 284L220 285.5L221.5 287L293.5 276L382.5 267L570.5 254L833.5 243L1066.5 239L1069 240.5L1070 244.5L1025.5 290L1014.5 295L960.5 295L888.5 298L751.5 310L636.5 326L516.5 348L361.5 384L233.5 420L93.5 466L18.5 494L3.5 500L0.5 503L148.5 473L319.5 445L454.5 429L592.5 419L648.5 417L752.5 417L836.5 421L945.5 433L1000.5 443L1034.5 452L1043.5 452L1050.5 449L1058 440.5L1072 406.5L1098 355.5L1118 321.5L1146 279.5L1197 214.5L1250 158.5L1250 154.5L1246.5 152L1224.5 150L1176.5 147L1092.5 146Z",
    fill: "#4A41C4",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiftxMark);
export default __webpack_public_path__ + "static/media/swiftx-mark.1f1b62d232d96c3466bb37d0eba405cb.svg";
export { ForwardRef as ReactComponent };